import { createRef } from 'react'

const HeroState = {
  pages: 3,
  top: createRef(),
}

export default HeroState
